export const languageConstants = {
	LanguageGetByFilterRequest: "LANGUAGE_GET_BYFILTER_STARTED",
	LanguageGetByFilterSuccess: "LANGUAGE_GET_BYFILTER_COMPLETED",
	LanguageGetByFilterFailure: "LANGUAGE_GET_BYFILTER_FAILED",

	LanguageDetailRequest: "LANGUAGE_GET_DETAIL_STARTED",
	LanguageDetailSuccess: "LANGUAGE_GET_DETAIL_COMPLETED",
	LanguageDetailFailure: "LANGUAGE_GET_DETAIL_FAILED",

	LanguageSaveRequest: "LANGUAGE_SAVE_STARTED",
	LanguageSaveSuccess: "LANGUAGE_SAVE_COMPLETED",
	LanguageSaveFailure: "LANGUAGE_SAVE_FAILED",

	LanguageUpdateRequest: "LANGUAGE_UPDATE_STARTED",
	LanguageUpdateSuccess: "LANGUAGE_UPDATE_COMPLETED",
	LanguageUpdateFailure: "LANGUAGE_UPDATE_FAILED",

	LanguageDeleteRequest : "LANGUAGE_DELETE_STARTED",
	LanguageDeleteSuccess : "LANGUAGE_DELETE_COMPLETED",
	LanguageDeleteFailure : "LANGUAGE_DELETE_FAILED",
}